<template>
  <div>
    <b-row
      v-if="$route.params.contractId">
      <b-col>
        <header-view
          :title="policyHolderName"
          :icon="'ti-user'">
        </header-view>
      </b-col>
    </b-row>

    <ContractOverview
      class="mt-4"
      v-if="$route.params.contractId && contract"
      :contract="contract"
      :contractCategories="contractCategories"
      :policyHolder="policyHolder"/>
    <b-btn
      class="mt-4"
      variant="link"
      :to="'/policyHolders/' + $route.params.id"
      v-if="$route.params.contractId">
      {{ $t('message.policyHolderContracts.back') }}
    </b-btn>

    <b-row v-if="!$route.params.contractId">
      <b-col>
        <b-row
          v-for="category in contractCategories"
          v-if="getContractsByCategory(category.value).length > 0"
          :key="category.value"
          class="mt-4">
          <b-col>
            <ContractsCard
              :collapseId="category.value + 'Id'"
              :title="category.text"
              :items="getContractsByCategory(category.value)"
              :phView="false"
              @showDetails="onShowDetails">
            </ContractsCard>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import HeaderView from '@/components/common/HeaderView'
  import ContractsCard from '@/components/contracts/ContractsCard'
  import ContractOverview from '@/components/contracts/ContractOverview'

  export default {
    name: 'PolicyHolderContracts',
    components: {
      HeaderView,
      ContractsCard,
      ContractOverview
    },
    computed: {
      contract () {
        const contractId = parseInt(this.$route.params.contractId)
        return this.$route.params.contractId ? this.$store.getters.policyHolderContracts.filter(contract => contract.id === contractId)[0] : null
      },
      contractCategories () {
        return this.$store.getters.contractCategories.map(category => {
          return {
            value: category,
            text: this.$t('enums.contractCategories.' + category)
          }
        })
      },
      policyHolder () {
        return this.$store.getters.policyHolder
      },
      policyHolderName () {
        return this.policyHolder.firstName + ' ' + this.policyHolder.lastName
      }
    },
    created () {
      if (!this.contract) {
        const id = parseInt(this.$route.params.id)
        if (id) {
          this.$store.dispatch('fetchPolicyHolderById', id)
            .then(() => {
              this.$store.dispatch('fetchContractsByPolicyHolderId', id)
            })
            .catch(() => {
              this.$router.replace('/policyHolders')
            })
        } else {
          this.router.replace('/policyHolders')
        }
      }
    },
    data () {
      return {}
    },
    methods: {
      getContractsByCategory (category) {
        return this.$store.getters.policyHolderContracts.filter(contract => contract.contractCategory === category)
      },
      onShowDetails (item) {
        this.$router.push({
          name: 'ViewPolicyHolderContracts',
          params: {id: parseInt(this.$route.params.id), contractId: item.id}
        })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/policyholder/PolicyHolderContracts.vue